import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"
import 'js-circle-progress'

// Connects to data-controller="components--avatar"
export default class extends Controller {
  static targets = [
    "avatarImage",
    "progressBarContainer",
    // "progressBar",
    "previewImage",
    "fileField"
  ]

  static values = {
    blobId: String
  }

  connect() {
    const cp = document.createElement('circle-progress')

    this.reCreateFormFileField()

    this.fileFieldTarget.addEventListener('change', (_) => { this.fileSelected() })
  }

  disconnect() {
    this.fileFieldTarget.removeEventListener('change', (_) => { this.fileSelected() })
  }

  fileSelected() {
    this.upload(this.fileFieldTarget.files[0])
    this.createPreviewImage()

    this.fileFieldTarget.value = ""
  }

  upload(file) {
    let url = this.fileFieldTarget.dataset.directUploadUrl
    let upload = new DirectUpload(file, url, this)

    upload.create((error, blob) => {
      if (error) {
        // FIXME: JS Avatar Upload Handle the error
      } else {
        this.createFormFileField(blob)
      }
    })
  }

  reCreateFormFileField() {
    if (this.hasBlobIdValue) {
      let hiddenField = document.createElement('input')

      hiddenField.setAttribute("type", "hidden")
      hiddenField.setAttribute("value", this.blobIdValue)
      hiddenField.name = this.fileFieldTarget.name

      this.element.appendChild(hiddenField)
    }
  }

  createFormFileField(blob) {
    let hiddenField = document.createElement('input')

    hiddenField.setAttribute("type", "hidden")
    hiddenField.setAttribute("value", blob.signed_id)
    hiddenField.name = this.fileFieldTarget.name

    this.element.appendChild(hiddenField)

    this.blobIdValue = blob.signed_id
  }

  createPreviewImage() {
    let src = URL.createObjectURL(this.fileFieldTarget.files[0])

    this.previewImageTarget.src = src
    this.previewImageTarget.classList.remove("hidden")

    this.removeAvatar()
  }

  directUploadWillStoreFileWithXHR(request) {
    this.progressBarContainerTarget.classList.remove("hidden")

    request.upload.addEventListener("progress", event => this.directUploadDidProgress(event))
  }

  directUploadDidProgress(event) {
    let progress = event.loaded / event.total * 100

    this.progressBarContainerTarget.value = Math.floor(progress)

    if (progress == 100) {
      setTimeout(() => { this.progressBarContainerTarget.classList.add("hidden") }, 1000)
    }
  }

  selectImage() {
    this.fileFieldTarget.click()
  }

  removeAvatar() {
    if (this.hasAvatarImageTarget) {
      this.avatarImageTarget.remove()
    }
  }
}
